const i18nConfig = {
    locales: ['en', 'fr', 'it', 'es', 'ar'],
    defaultLocale: 'en'
}

export default i18nConfig
